export default function LuckySecRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                `}
            </style>

            <div class="modal fade show" style={{ display: "block", paddingLeft: "0px", marginBottom: "20px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Lucky 7</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">To predict the value of the card drawn is Low Card or High Card.</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b> Hands Dealt:</b>1 (Low Card/ High Card)</p>
                                            <p class="pt20"><b>Bets:</b></p>
                                            <p class="pt20"><b>High Card wins</b>: If dealt hand is &gt; 7 (8, 9, 10, J, Q, K)</p>
                                            <p class="pt20">
                                                <b>Low Card wins:</b>
                                                If dealt hand is &lt; 7 (A, 2, 3, 4, 5, 6).
                                            </p>
                                        </div>

                                        <div>
                                            <div>
                                                <center><h3>PAYOUTS</h3></center>
                                                <div>
                                                    <p class="pt20">Payout as per the bet placed. </p>
                                                    <table class="table table-bordered table-sm">
                                                        <tbody>
                                                            <tr>
                                                                <th>Low Card</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>High Card</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Even</th>
                                                                <th>
                                                                    1 to 1.1
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Odd</th>
                                                                <th>
                                                                    1 to 0.8
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Red</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>Black</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>Suit</th>
                                                                <th>
                                                                    1 to 2.75
                                                                </th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div>
                                                        <p class="pt20">
                                                            <b>Note:</b> In case a card with rank 7 is dealt,
                                                            50% of the bet amount will be returned to the player
                                                            (for <strong>Low Card</strong> and <strong>High Card</strong> selections only).
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}